<input type="text" [ngModel]="value" (ngModelChange)="changeValue($event)" placeholder="http://">
